<template>
  <div class="wine-team">
    <header class="section-header background-yellow">
      <h1>We’re here to give you unprecedented access.</h1>
    </header>
    <div class="jumplinks mobile-scroll">
      <ul>
        <li v-for="oenologist in wineTeam" :key="oenologist.id">
          <a :href="`#${oenologist.occasion_slug}`">
            {{ oenologist.name }}
            <span v-if="oenologist.expertise === 'Master Sommelier'"
              >MS</span
            ></a
          >
        </li>
      </ul>
    </div>
    <TeamMemberBio
      v-for="oenologist in wineTeam"
      :id="oenologist.occasion_slug"
      :key="oenologist.id"
      :shaded="oenologist.position % 2 === 0"
      :name="oenologist.name"
      :member-title="oenologist.expertise"
      :products="oenologist.occasion_products || []"
      :expand-bio-title="`Read about ${oenologist.first_name}`"
      :carousel-title="`${oenologist.first_name}'s wine picks`"
      :extra-card-url="`/store/occasion/${oenologist.occasion_slug}/`"
      :extra-card-text="`Discover more from ${oenologist.first_name}'s collection`"
    >
      <template #memberImage>
        <img
          :src="oenologist.photo_image"
          role="presentation"
          :alt="`Portrait of ${oenologist.name}`"
          data-not-lazy
        />
      </template>
      <template #summary>
        <span v-html="oenologist.biography"></span>
      </template>
      <template #quote>
        <blockquote v-html="oenologist.personal_note"></blockquote>
      </template>
    </TeamMemberBio>
    <section v-if="displayQESCTA" class="wine-team-qes">
      <div v-if="!registerSuccess && !qesDisplayed" class="cta-callout">
        <div class="text">
          <p>
            Get our best finds and the stories behind them delivered to your
            inbox.
          </p>
          <button class="button primary" @click="showQes">Sign Up</button>
        </div>
      </div>
      <section class="email-signup">
        <div v-if="qesDisplayed" class="qes-container home-email-modal">
          <QesThankYou v-if="registerSuccess" />
          <QuickEmailSignup
            v-if="!registerSuccess"
            :auto-focus="true"
            @closed="qesDisplayed = false"
            @register-success="registerSuccess = true"
          />
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    TeamMemberBio: defineAsyncComponent(
      () => import('@/components/WineTeam/TeamMemberBio'),
    ),
    QesThankYou: defineAsyncComponent(
      () => import('@/components/Index/QesThankYou'),
    ),
    QuickEmailSignup: defineAsyncComponent(
      () => import('@/components/Index/QuickEmailSignup'),
    ),
  },
  async setup() {
    const {
      data: {
        value: { results: wineTeam },
      },
    } = await useFetch('/api/catalog/oenologists/', {
      params: { 'wine-team': true },
    })

    wineTeam.forEach((o) => {
      o.personal_note = `“${o.personal_note}”`
      o.first_name = o.name.split(' ')[0]
    })

    // scrollToProductInCarousel(this.$nextTick)

    return {
      qesDisplayed: ref(false),
      registerSuccess: ref(false),
      wineTeam,
    }
  },
  head: {
    title: 'Meet The Wine Team | WineAccess',
  },
  computed: {
    ...mapGetters(['qes']),
    displayQESCTA() {
      return (
        this.qesDisplayed ||
        this.registerSuccess ||
        (!this.loggedIn && !(this.qes || this.$cookies.get('new-quicksignup')))
      )
    },
    loggedIn() {
      return this.$auth.loggedIn
    },
  },
  mounted() {
    if (this.$route.hash) {
      this.$nextTick(() =>
        setTimeout(() => this.$scrollTo(this.$route.hash), 2000),
      )
    }
  },
  methods: {
    showQes() {
      this.qesDisplayed = true
    },
  },
}
</script>
